// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/SwitchesPanelItem/SwitchesPanelItem.less
// module id = 237
// module chunks = 2